import React from "react";
import { Helmet } from "react-helmet-async";
import GetStarted from "../components/GetStarted";
import Header from "../components/Header";
import Footer from "../components/Footer/Footer";
import BarraApp from "../componentsPeopletech/Barraaps";

const Home = () => {
  const baseUrl = "https://www.peoplefortech.com";
  const pageUrl = `${baseUrl}/sammy/home`;

  return (
    <>
      <Helmet>
        {/* Meta tags básicos */}
        <title>Sammy - Inicio</title>
        <meta name="description" content="Sammy: actividades y soporte multilenguaje para tu día a día." />
        <meta name="keywords" content="sammy, app, idiomas, actividades, aprendizaje" />
        <link rel="canonical" href={pageUrl} />
        
        {/* Open Graph / Facebook */}
        <meta property="og:type" content="website" />
        <meta property="og:url" content={pageUrl} />
        <meta property="og:title" content="Sammy - Inicio" />
        <meta property="og:description" content="Sammy: actividades y soporte multilenguaje para tu día a día." />
        <meta property="og:image" content={`${baseUrl}/SEO_IA_1.png`} />
        
        {/* Twitter */}
        <meta property="twitter:card" content="summary_large_image" />
        <meta property="twitter:url" content={pageUrl} />
        <meta property="twitter:title" content="Sammy - Inicio" />
        <meta property="twitter:description" content="Sammy: actividades y soporte multilenguaje para tu día a día." />
        <meta property="twitter:image" content={`${baseUrl}/SEO_IA_1.png`} />
        
        {/* Schema.org JSON-LD para SEO de IA */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "Organization",
            "name": "Sammy",
            "url": pageUrl,
            "description": "Sammy: actividades y soporte multilenguaje para tu día a día.",
            "logo": `${baseUrl}/favicon.ico`
          })}
        </script>
      </Helmet>
      <BarraApp />
      <Header />
      <GetStarted />
      <Footer />
    </>
  );
};

export default Home;
